// Mirrors Blizzard's Enum.TraitNodeFlag from:
// Interface/AddOns/Blizzard_APIDocumentationGenerated/TraitConstantsDocumentation.lua
export enum ETraitNodeFlag {
  ShowMultipleIcons = 1,
  NeverPurchasable = 2,
  TestPositionLocked = 4,
  TestGridPositioned = 8,
  ActiveAtFirstRank = 16,
  ShowExpandedSelection = 32,
  HideMaxRank = 64,
  HighestChosenRank = 128,
  ShowTierTrack = 256
}

// Observed on tiered apex/capstone nodes that were previously matched via the raw value 264.
export const TIERED_APEX_NODE_FLAGS = [
  ETraitNodeFlag.TestGridPositioned | ETraitNodeFlag.ShowTierTrack,
  ETraitNodeFlag.ShowTierTrack
];

export function hasTraitNodeFlag(flags: number | undefined, flag: ETraitNodeFlag): boolean {
  return typeof flags === 'number' && (flags & flag) === flag;
}

export function hasTraitNodeFlags(flags: number | undefined, mask: number): boolean {
  return typeof flags === 'number' && (flags & mask) === mask;
}

export const hasSomeTraitNodeFlags = (flags: number | undefined, masks: number[]): boolean => {
  return typeof flags === 'number' && masks.some((mask) => hasTraitNodeFlags(flags, mask));
};
